<template>
  <div class="row">
    <div class="col-md-12">
      <HistoryOrder :biList="biList" @chooseBiById="chooseBiById" />
    </div>
  </div>
</template>

<script>
import HistoryOrder from "@/components/HistoryOrder.vue";
export default {
  components: { HistoryOrder },
  computed: {
    biList() {
      return this.$store.state.biList;
    },
  },
  methods: {
    chooseBiById(bi_id) {
      const find = this.biList.find((bi) => bi.bi_id === bi_id);
      if (find) {
        this.$store.commit("setSelectedBi", find);
      }
      this.$router.push("/trade");
    }
  }
};
</script>

<style>

</style>
